import * as jwtDecode from 'jwt-decode';

const win = window as Bee.WindowExtended;
const AWS = win.AWS

export const loginUrl = 
	'https://auth.3dbee.org/login?response_type=token&client_id=79dpe957qhplmm0a8s4cju3qja&redirect_uri=https://3dbee.org';

export const adminGroups = ['administrators', 'creators'];

export const isUserAdmin = () => {
	const groups = getUserData()['cognito:groups'];

	if (!groups) {
		return false;
	}

	return groups.some((groupName: string) => (
		adminGroups.includes(groupName.toLowerCase())
	));
}

export const getAuthParams = (): Bee.AuthParams => {
	try {
		const url = window.location.href;
		const data = url.split('#')[1].split('&');
		const params = {} as Bee.AuthParams;

		data.forEach((d: any, ix: number) => {
			const s = data[ix].split('=');
			params[s[0]] = s[1];
		});

		if ( params.error ) {
			console.log(params.error);
		}
		return params;
	} catch(e) {
		console.error('Unable to parse authentication params from URL');
		return {} as Bee.AuthParams;
	}
}

export const getUserData = (): Bee.TokenData => {
	try {
		const auth = getAuthParams();
		return jwtDecode(auth.access_token);
	} catch (e) {
		console.error('Unable to parse authentication token');
		return {
			username: '',
			'cognito:groups': [],
		};
	}
}

export const getClient = () => {
	return win.apigClientFactory.newClient({
		accessKey: AWS.config.credentials.accessKeyId,
		secretKey: AWS.config.credentials.secretAccessKey,
		sessionToken: AWS.config.credentials.sessionToken,
		region: AWS.config.region
	});
}

export const credentialsAreValid = async () => {
	try {
		await AWS.config.credentials.getPromise();
		console.log('Credentials are good, ok to proceed');
		return true;
	} catch(e) {
		console.error(e);
		return false;
	}

}

export const configureAWS = () => {
	AWS.config.region = 'us-east-2';

	const params = getAuthParams();

	AWS.config.credentials = new (AWS.CognitoIdentityCredentials as any)({
		IdentityPoolId: 'us-east-2:5eac8ede-8bea-444e-8a03-daf0e9cc79c9',
		Logins: {
			'cognito-idp.us-east-2.amazonaws.com/us-east-2_aEjtQAeYj': params.id_token
		}
	});
}

export const getUser = () => {
	const params = getAuthParams();

	// Get User attributes (e.g. name, email, etc.)
	const sp = new (AWS.CognitoIdentityServiceProvider as any)();
	sp.getUser({ AccessToken : params.access_token}, (e: any, d: any) => {
		if (e) {
			console.log(e, e.stack);
			return null;
		}
		else {
			console.log(d);
			const attr = {} as any;

			d.UserAttributes.forEach((a: any, ix: number) => {
				attr[d.UserAttributes[ix].Name] = d.UserAttributes[ix].Value;
			});

			console.log('Welcome to blah ' + attr.name);
			return d;
		}
	});
}



// WEBPACK FOOTER //
// ./src/api/auth.ts